module.exports = __webpack_public_path__ + "media/images/weleda_logo_grey_reduced_nav-238da32869ca9bc59d7f3d5e95cd72bc.png";